import { Ref } from 'vue';
import { tagField } from '@/ui/components/form';
import { updateMultiple } from '@/ui/queryState';
import { PaginationResetCallback, SelectOptions } from '@/ui/types';

export const tagFilter = <T>({
  value,
  name,
  label,
  placeholder,
  options,
  reset,
  hideLabel,
  horizontal,
  isStackable,
  maxListedOptions,
}: {
  value: Ref<T[]>;
  name: string;
  label: string;
  placeholder: string;
  options: SelectOptions<T>;
  reset: PaginationResetCallback;
  hideLabel?: boolean;
  horizontal?: boolean;
  isStackable?: boolean;
  maxListedOptions?: number;
}) => tagField<T>(
  {
    value: value.value,
    name,
    label,
    placeholder: value.value.length > 0 ? '' : placeholder,
    options,
    required: false,
    errors: [],
    disabled: false,
    hideLabel,
    horizontal,
    isStackable,
    maxListedOptions,
  },

  v => updateMultiple(() => {
    reset();
    value.value = v;
  }, true),
);
